module.exports = __webpack_public_path__ + "img/trash.cf9b8d8e.svg";